// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N200, N800 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsOptionsWrapper = styled.span({
  zIndex: 1,
  right: 0,
  display: 'flex',
  paddingTop: "var(--ds-space-250, 20px)",
  paddingRight: "var(--ds-space-300, 24px)",
  minHeight: "var(--ds-space-400, 32px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIOptionsMenuWrapper = styled.div({
  display: 'flex',
  paddingTop: "var(--ds-space-200, 16px)",
  paddingBottom: "var(--ds-space-200, 16px)",
  gap: "var(--ds-space-250, 20px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIOptionsMenuOptionWrapper = styled.div({
  paddingLeft: "var(--ds-space-150, 12px)",
  paddingRight: "var(--ds-space-075, 6px)",
  width: '320px',
  display: 'flex',
  flexDirection: 'row',
  gap: "var(--ds-space-250, 20px)",
  justifyContent: 'space-between'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIOptionsMenuOptionText = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: "var(--ds-space-050, 4px)",
  width: '244px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIOptionsMenuOptionHeader = styled.div({
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text, ".concat(N800, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIOptionsMenuOptionDescription = styled.div({
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-subtlest, ".concat(N200, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIOptionsMenuOptionToggleWrapper = styled.div({
  display: 'flex',
  width: 'fit-content'
});